module.exports = __webpack_public_path__ + "static/media/Login.e0359c7c.png";